import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { AuthContext } from "../../AuthContext";
import ImageComponent from "../articales/ImageComponent";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

const itemsPerPage = 3; // Number of items per page

const Favorite = () => {
  const { favoriteItem, auth } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(favoriteItem.length / itemsPerPage);

  // Calculate the items for the current page
  const currentItems = favoriteItem.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div id="favorite" style={{height:"124vh"}}> 
      <section className="vh-100 w-100 bg-black row  align-items-center flex-column ">
        <div className="col-lg-10 col-md-6 col-sm-10 h-sm-100 h-lg-75 w-sm-100 w-md-100 w-lg-75 ">
        <div>
            <h5>favorites</h5>
            <hr />
          </div>
          <div className="h-100 d-flex justify-content-center align-items-center bgHome pt-3 pb-3 rounded-5 flex-column">
          { favoriteItem.length === 0 && <Link to="/articles" className="w-75 my-3">
              <button
                type="submit"
                className="py-3 d-block w-100 btnCustom m-auto rounded-4"
              >
                Add Favorite Articles
                <FontAwesomeIcon className="ms-2 fs-5" icon={faCirclePlus} />
              </button>
            </Link>}
            {auth.user && (
              <>
                <div style={{ width: "70%", margin: "15px auto " }}>
                  {currentItems.map((item) => (
                    <div
                      key={item.id}
                      style={{
                        color: "blue",
                        padding: "3px 9px",
                        width: "100%",
                        border: "1px solid #fff",
                        marginBottom: "8px",
                        borderRadius: "10px",
                        display: "flex",
                        flexWrap: "nowrap",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        paddingTop: "12px",
                      }}
                      >
                      <div style={{width:"30%"}} >
                        <ImageComponent height={'100px'} base64String={item.image}/>
                      </div>
                      <div style={{width:"66%"}}>
                      <div style={{fontSize:"17px", fontWeight:"bold",color:"black",opacity:".8" }}>{item.categoryName}</div>
                      <div style={{ color:"black",opacity:".7",overflow:"hidden",height:"70px" }}>{item.description}</div>
                      <div style={{color:"black",textAlign:"end",opacity:".7",padding:"7px 15px"}}>
                        <FontAwesomeIcon icon={faHeart}/>
                      </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Pagination controls */}
              { favoriteItem.length !== 0 && <div className="pagination ">
                  <button
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                    style={{marginLeft:"8px",border:"1px solid blue",color:"#aaa"}}
                    className="rounded-pill px-3 me-2 "
                  >
                    Previous
                  </button>

                  {/* Page numbers */}
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => handlePageClick(index + 1)}
                      className={`px-3 rounded-pill ${currentPage === index + 1 ? "bg-primary"  : ""}`}
                      style={{border:"1px solid blue"}}
                    >
                      {index + 1}
                    </button>
                  ))}

                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    style={{marginLeft:"8px",border:"1px solid blue",color:"#aaa"}}
                    className="rounded-pill px-3 me-2 "
                  >
                    Next
                  </button>
                </div>}
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Favorite;
